import { RecordValue } from "libs/schema";
import { useCallbackAt } from "./useCallbackAt";

export function useIsMessageSent(message: Pick<RecordValue<"message">, "sent_at"> | null | undefined) {
  return useCallbackAt(() => (message ? message.sent_at <= new Date().toISOString() : false), [message?.sent_at]);
}
